module.exports = __webpack_public_path__ + "media/img/patterns/topographic-pattern-dark-d91a7ee6083bc85a13b6550ad5b96b2f.png";